module.exports = __webpack_public_path__ + "img/shape-4.32925d0c.png";